<div class="header-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="header-widget">
                    <ul>
                        <li><i class="icofont-clock-time"></i> Monday - Saturday 8:00 - 18:00</li>
                        <li><i class="icofont-ui-message"></i><a href="mailto:contact@hikmatex.ma">contact@hikmatex.ma</a></li>
                        <li><i class="icofont-ui-message"></i><a href="mailto:export@hikmatex.ma">export@hikmatex.ma</a></li>
                        <li><i class="icofont-phone"></i> <a href="tel:+2120808608496">+212 8 08 60 84 96</a></li>
                    </ul>
                </div>
            </div>

            <!-- <div class="col-md-4">
                <div class="header-social text-end">
                    <ul>
                        <li><a target="_blank" href="#"><i class="icofont-facebook"></i></a></li>
                        <li><a target="_blank" href="#"><i class="icofont-twitter"></i></a></li>
                        <li><a target="_blank" href="#"><i class="icofont-linkedin"></i></a></li>
                        <li><a target="_blank" href="#"><i class="icofont-instagram"></i></a></li>
                    </ul>
                </div>
            </div> -->
        </div>
    </div>
</div>

<div class="navbar-area">
    <div class="mobile-nav mean-container">
        <div class="mean-bar">
            <a class="meanmenu-reveal" (click)="toggleMenu=!toggleMenu">
                <span>
                    <span><span></span></span>
                </span>
            </a>
            <nav class="mean-nav" [ngClass]="{'hidden':toggleMenu}">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                            Home
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/about" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                            About
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/products" class="nav-link" routerLinkActive="active" i18n>
                            Products
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/news" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                            News
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                            Contact
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
        <a routerLink="/" class="logo">
            <img src="assets/img/logo.svg" alt="logo">
        </a>
    </div>

    <div class="main-nav">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" href="index.html">
                    <img src="assets/img/logo.svg" class="logo" alt="logo">
                </a>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto">
                        <li class="nav-item">
                            <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                                Home
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/about" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                                About
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/products" class="nav-link" routerLinkActive="active" i18n>
                                Products
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/news" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                                News
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" i18n>
                                Contact
                            </a>
                        </li>
                    </ul>

                    <!-- <div class="navbar-button">
                        <a routerLink="#" i18n>
                            <i class="icofont-user-alt-3 mr-1"></i>
                            Login
                        </a>
                    </div> -->
                </div>
            </nav>
        </div>
    </div>
</div>
